/**
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 * */

import { ContextMenuOperation } from './context-menu-operation';
import { TemplateType } from './template-type';

/**
 * WorkListRow Interface
 *
 * It Represents a row in the virtual grid
 **/
export interface VirtualGridRow {
  /**
   * The row object containing the data to be displayed
   */
  data: any;

  /**
   * Custom template to be used as row.
   * If not defined, a default template is used.
   * When presented, the grid will not print and manage cells.
   * The template is responsible for presenting the desired layout for the cells.
   * The row hight should match the itemSize input of the work list component.
   *
   * the following context variable are exposed to the template:
   * * layout : layout configuration from the layout input
   * * item   : the item object containing row data
   * * rIndex  : row index
   */
  rowTemplate: TemplateType;

  contextMenuOperations?: ContextMenuOperation[];

  [key: string]: any;
}

export function isVirtualGridRow(obj: any): boolean {
  return !!(obj && 'data' in obj && 'rowTemplate' in obj);
}
